module.exports = __webpack_public_path__ + "static/img/956路.791161f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/956路.jpg
// module id = kOKn
// module chunks = 2